import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import GroupedCardsItem from './GroupedCardsItem';

import './GroupedCards.scss';

const renderButton = (buttonProps) => {
  const { label, ...props } = buttonProps;

  return (
    <button
      className="hot-button hot-button--tertiary"
      data-test="card-button"
      key="card-button"
      {...props}
    >
      <I18n label={label} />
      <FontAwesomeIcon icon={['fal', 'arrow-right']} className="_ml-2" />
    </button>
  );
};

const GroupedCards = ({ className, children, title, buttonProps }) => {
  const parentClassNames = classnames('grouped_card__container', className);

  return (
    <div className={parentClassNames}>
      <h3 className="grouped_card__header">
        <div className="grouped_card__title" data-test="card-title">
          {title}
        </div>
        {buttonProps && renderButton(buttonProps)}
      </h3>
      <div className="grouped_card__list">{children}</div>
    </div>
  );
};

GroupedCards.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string,
  buttonProps: PropTypes.shape({
    label: PropTypes.string
  })
};

GroupedCards.Item = GroupedCardsItem;

export default GroupedCards;
